//                                      ELHAMDÜLİLLAH


import React, {useState, useEffect} from 'react'
import {HeroContainer, HeroBg, VideoBg, HeroContent, HeroH1, HeroP, HeroBtnWrapper, ArrowForward, ArrowRight} from './HeroElements';
import Video from '../../videos/video.mp4';
import VideoMobile from '../../videos/video(1).mp4';
import {Turkish, English} from '../../strings/index';
import detectLanguage from '../common';
import {Button} from '../ButtonElements';

let Language;
if (detectLanguage() == "en-US")
    Language = English;
else
    Language = Turkish;
console.log(Language)

const HeroSection = () => {

    const [width, setWidth] = useState(window.innerWidth);
    const [hover, setHover] = useState(false);

    const onHover = () => {
        setHover(!hover);
    }
    const handleWindowSizeChange = () => {
            setWidth(window.innerWidth);
    }
    
    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    let isMobile = (width <= 768);

    return (
        <>
            <HeroContainer id="starting">
                <HeroBg>
                    <VideoBg playsInline autoPlay loop muted src={isMobile ? VideoMobile : Video} type='video/mp4'></VideoBg>
                </HeroBg>
                
                <HeroContent>
    <HeroH1>{Language.HeroSection.H1}</HeroH1>
                    <HeroP>
                        {Language.HeroSection.P}
                    </HeroP>
                    <Button
                     smooth={true}
                     duration={500}
                     spy={true}
                     exact="true"
                     offset={100}
    primary={false} dark={true} to={Language.Navbar.LinkHelpers[0]} onMouseEnter={onHover} onMouseLeave={onHover}> {Language.HeroSection.Button}{ hover ? <ArrowForward /> : <ArrowRight /> } </Button>

                </HeroContent>

                <HeroBtnWrapper>
                </HeroBtnWrapper>
            </HeroContainer>
        </>
    )
}


export default HeroSection;